(function () {
  function init(bar) {
    if (bar.dataset.stickyAtcInit) return;
    bar.dataset.stickyAtcInit = 'true';

    var section = bar.closest('[data-product-section]');
    if (!section) return;

    // The old bar only exists when "Enable sticky add to cart bar" is on in the section settings.
    if (!section.querySelector('.product-sticky-bar:not(.sticky-atc)')) {
      bar.remove();
      return;
    }

    var variantsNode = bar.querySelector('[data-sticky-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]');
    } catch (error) {
      return;
    }

    var selects = Array.prototype.slice.call(bar.querySelectorAll('[data-sticky-option-select]'));
    var priceEl = bar.querySelector('[data-sticky-price]');
    var compareEl = bar.querySelector('[data-sticky-compare]');
    var imageEl = bar.querySelector('[data-sticky-image]');
    var idInput = section.querySelector('[data-variant-id-input]');

    function currentVariant() {
      var id = idInput ? Number(idInput.value) : 0;
      return variants.find(function (variant) { return variant.id === id; });
    }

    function sync() {
      var variant = currentVariant();
      if (!variant) return;

      selects.forEach(function (select) {
        var index = Number(select.dataset.optionIndex);
        if (variant.options[index] !== undefined) select.value = variant.options[index];
      });

      if (compareEl) {
        compareEl.hidden = !variant.compare;
        compareEl.textContent = variant.compare || '';
      }

      if (imageEl && variant.image) imageEl.src = variant.image;
    }

    // Mirror a dropdown choice onto the main option picker so product-page.js resolves the variant.
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var name = select.dataset.optionName;
        var value = select.value;

        var button = Array.prototype.slice
          .call(section.querySelectorAll('[data-option-button]'))
          .find(function (item) {
            return item.dataset.optionName === name && item.dataset.optionValue === value;
          });

        if (button && !button.disabled) {
          button.click();
        } else {
          var mainSelect = Array.prototype.slice
            .call(section.querySelectorAll('[data-option-select]'))
            .find(function (item) { return item.dataset.optionName === name; });

          if (mainSelect) {
            mainSelect.value = value;
            mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        // If nothing changed (e.g. sold-out value), snap back to the current variant.
        sync();
      });
    });

    // product-page.js rewrites the sticky price on every variant change; use that as the signal to sync.
    if (priceEl && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    sync();
  }

  function initAll() {
    document.querySelectorAll('.sticky-atc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
